<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-29 16:29:58
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-12-06 14:03:15
-->
<template>
	<div class="flex-column flex-align-center" :style="'padding: 140px 0 0;box-sizing: border-box;height: ' + pageHeight + 'px'" ref="page">
		<!-- 无数据 -->
		<img width="160" height="160" class="mb-16" src="@/assets/empty/empty-img@4x.png" />
		<p class="font-h1-medium">敬请期待</p>
		<p class="font-h6-regular yx-color-text-regular">联系销售顾问, 开启完整服务</p>
	</div>
</template>
<script>
export default {
	name: 'ExpectEmpty',
	data() {
		return {
			pageHeight: '',
		};
	},
	mounted() {
		const pageTop = this.$refs?.page?.getBoundingClientRect().top;
		this.pageHeight = document.documentElement.clientHeight - pageTop - 24;
	},
};
</script>
